<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.79 3.3H20.6667C21.95 3.3 23 4.335 23 5.6V21.7C23 22.965 21.95 24 20.6667 24H4.33333C3.05 24 2 22.965 2 21.7V5.6C2 4.335 3.05 3.3 4.33333 3.3H9.21C9.7 1.966 10.9833 1 12.5 1C14.0167 1 15.3 1.966 15.79 3.3ZM13.6667 4.45C13.6667 3.8175 13.1417 3.3 12.5 3.3C11.8583 3.3 11.3333 3.8175 11.3333 4.45C11.3333 5.0825 11.8583 5.6 12.5 5.6C13.1417 5.6 13.6667 5.0825 13.6667 4.45ZM12.5 7.9C14.4367 7.9 16 9.441 16 11.35C16 13.259 14.4367 14.8 12.5 14.8C10.5633 14.8 9 13.259 9 11.35C9 9.441 10.5633 7.9 12.5 7.9ZM5.5 20.09V21.7H19.5V20.09C19.5 17.79 14.8333 16.525 12.5 16.525C10.1667 16.525 5.5 17.79 5.5 20.09Z" 
            fill="black"
        />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPass',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>